/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import AdminLayout from "./AdminLayout";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import './AdminComponentsEdit.css';
import CodeEditor from "../CodeEditor";
import React from "react";
import ViewFixed from "../ViewFixed";

class AdminComponentsEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
        this.previewRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.params.id) {
            qreq.get('/api/admin/com/get?id=' + this.props.params.id, j => {
                if (j.item) {
                    this.setState({ info: j.item });
                    setTimeout(() => {
                        this.updatePreview(j.item);
                    }, 200);
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }
    }

    change = (name, value) => {
        let info = { ...this.state.info };
        info[name] = value;
        this.setState({ info });
        this.updatePreview(info);
    }

    updatePreview = (info) => {
        const ele = this.previewRef.current;

        ele.innerHTML = info.renderHTML;
    }

    submit = (e) => {
        if (e) e.preventDefault();
        qreq.post('/api/admin/com/save', { ...this.state.info }, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else {
                this.success('Component saved!');
                this.props.navigate('/admin/com');
            }
        }, this.unkownErrorCallback);
    }

    render() {
        return <AdminLayout>
            <div className="container-fluid">
                <form onSubmit={this.submit}>
                    <ViewFixed minimize bottom="100px" right="0" width="25%" className="px-2 border-1 rounded bg-light" overflow="hidden">
                        <h5>Properties</h5>
                        <FormInput model={this.state.info} name="name" label="Component Name" labelAsPlaceholder />
                    </ViewFixed>
                    <div className="com-edit-html">
                        <div className="com-edit-lang">HTML</div>
                        <CodeEditor lang="html" height="100%" code={this.state.info.renderHTML} onChange={(v) => this.change('renderHTML', v)} theme="vs-light" />
                    </div>
                    <div className="com-edit-js">
                        <div className="com-edit-lang">JavaScript</div>
                        <CodeEditor lang="javascript" height="100%" code={this.state.info.renderJS} onChange={(v) => this.change('renderJS', v)} theme="vs-light" />
                    </div>
                    <div className="com-edit-preview">
                        <div ref={this.previewRef}></div>
                    </div>
                    <div className="app-form-buttons">
                        <button onClick={this.goBack} type="button" className="btn btn-secondary"><Icon icon="faCancel" /> Cancel</button>
                        <button type="submit" className="btn btn-success"><Icon icon="faSave" /> Save</button>
                    </div>
                </form>
            </div>
        </AdminLayout>
    }
}

export default withParamsAndNavigate(AdminComponentsEdit);